module.exports = __webpack_public_path__ + "smart-campaign-assessment.7482c1f0ee39b1d8a5da2b19a043d4cb.jpg";